/**
 * Was beide Oberflächen über die Messung wissen müssen: die Property, mit der
 * gemessen wird, und das Werbekonto, dem Abschlüsse gemeldet werden.
 *
 * Two surfaces measure with the same Analytics property — `easyrechnung.at`
 * counts who reads what, `app.easyrechnung.at` counts the one thing that
 * happens behind the login and is worth counting: a subscription that comes
 * about. One property, so a visit and the subscription it leads to are the
 * same session rather than two unrelated ones. One ID, therefore, in one
 * place; both apps derive it from here.
 *
 * Die Zustimmung selbst liegt in `consent.ts` — ein Wortlaut, ein Nachweis,
 * ein Cookie für beide Hosts. Both files describe the same measurement; this
 * one says where it goes, that one what was agreed to.
 */
/**
 * The Analytics property both surfaces measure with.
 *
 * Not a secret: it is in every request a consenting visitor makes. It lives in
 * the repository rather than in an environment file so that a deploy which
 * forgets a variable cannot silently stop the measurement — the kind of
 * failure that is noticed a quarter late. Each app may still override it
 * (`NUXT_PUBLIC_GA4_ID`, `VITE_GA4_ID`) to point a test build at a second
 * property.
 */
export const GA4_MEASUREMENT_ID = 'G-SLLC8TFT6S';
/**
 * Das Google-Ads-Konto, an das Abschlüsse gemeldet werden — leer, solange es
 * keines gibt.
 *
 * Two ways lead to a conversion in Google Ads, and this is the more accurate
 * one: the event goes straight to the Ads account (`AW-…`), at the moment it
 * happens, with the click identifier that is still in the browser. The other
 * way needs no code at all — link Analytics to Ads and import `sign_up` and
 * `purchase` as key events — but it arrives later, and it can only carry what
 * Analytics already attributed.
 *
 * Empty means nothing is sent and nothing is loaded: the ID is a value, not a
 * branch, so the day it is filled in is a one-line change with a test already
 * around it. Each conversion action in Ads has its own label; both belong to
 * the same account.
 */
export const ADS_CONVERSION_ID = '';
/** The label of each conversion action, from the Ads account. */
export const ADS_CONVERSION_LABELS = {
    sign_up: '',
    purchase: '',
};
/**
 * `AW-…/…` for an event, or `null` while the account is not configured.
 *
 * Both halves have to be there. An ID without a label reaches the account and
 * lands in no conversion action, which looks exactly like a working setup
 * until somebody opens the report.
 */
export function adsSendTo(event) {
    const label = ADS_CONVERSION_LABELS[event];
    if (!ADS_CONVERSION_ID || !label)
        return null;
    return `${ADS_CONVERSION_ID}/${label}`;
}
//# sourceMappingURL=analytics.js.map